export default function AppFooter() {
    return (
        <footer className="mt-16 border-t border-white/10 bg-[#090c12]">
            <div className="mx-auto flex max-w-[1400px] flex-col gap-3 px-4 py-8 md:px-6 lg:px-8">
                <p className="text-sm font-black uppercase tracking-wide text-white">
                    Ligue des 2 Zéros
                </p>
                <p className="max-w-3xl text-sm text-white/60">
                    Plateforme média de la Ligue des 2 Zéros du Luxembourg et des 3 Frontières :
                    actualités, affiches officielles, événements, résultats et vie de la communauté.
                </p>
                <p className="text-xs uppercase tracking-[0.2em] text-white/40">
                    © 2026 Ligue des 2 Zéros - Tous droits réservés
                </p>
            </div>
        </footer>
    );
}